import { rolesMessages } from 'src/features/roles/utils/messages';
import { PERMISSION } from 'src/features/auth/types';

const USERS_SECTIONS_PERMISSION = [
    {
        value: PERMISSION.ACCESS_USERS,
        label: rolesMessages.accessUsers,
    },
    {
        value: PERMISSION.MANAGE_USERS,
        label: rolesMessages.manageUsers,
    },
    {
        value: PERMISSION.ACCESS_ROLES,
        label: rolesMessages.accessRoles,
    },
    {
        value: PERMISSION.MANAGE_ROLES,
        label: rolesMessages.manageRoles,
    },
];

const CUSTOMERS_PERMISSION = [
    {
        value: PERMISSION.ACCESS_CUSTOMERS,
        label: rolesMessages.accessCustomers,
    },
    {
        value: PERMISSION.MANAGE_CUSTOMERS,
        label: rolesMessages.manageCustomers,
    },
];

const BILLING_SETTINGS_SECTION_PERMISSION = [
    {
        value: PERMISSION.ACCESS_BILLING_ENTITIES,
        label: rolesMessages.accessBillingEntities,
    },
    {
        value: PERMISSION.MANAGE_BILLING_ENTITIES,
        label: rolesMessages.manageBillingEntities,
    },
    {
        value: PERMISSION.ACCESS_MONEY_ACCOUNTS,
        label: rolesMessages.accessMoneyAccounts,
    },
    {
        value: PERMISSION.MANAGE_MONEY_ACCOUNTS,
        label: rolesMessages.manageMoneyAccounts,
    },
    {
        value: PERMISSION.ACCESS_ACCOUNTING_HEADINGS,
        label: rolesMessages.accessAccountingHeadings,
    },
    {
        value: PERMISSION.MANAGE_ACCOUNTING_HEADINGS,
        label: rolesMessages.manageAccountingHeadings,
    },
    {
        value: PERMISSION.ACCESS_ACCOUNTING_RANGES,
        label: rolesMessages.accessAccountingRanges,
    },
    {
        value: PERMISSION.MANAGE_ACCOUNTING_RANGES,
        label: rolesMessages.manageAccountingRanges,
    },
    {
        value: PERMISSION.ACCESS_UNITS,
        label: rolesMessages.accessUnits,
    },
    {
        value: PERMISSION.MANAGE_UNITS,
        label: rolesMessages.manageUnits,
    },
];

const DISCOUNTS_SECTION_PERMISSION = [
    {
        value: PERMISSION.ACCESS_DISCOUNTS,
        label: rolesMessages.accessDiscounts,
    },
    {
        value: PERMISSION.MANAGE_DISCOUNTS,
        label: rolesMessages.manageDiscounts,
    },
    {
        value: PERMISSION.ACCESS_VOUCHERS,
        label: rolesMessages.accessVouchers,
    },
    {
        value: PERMISSION.MANAGE_VOUCHERS,
        label: rolesMessages.manageVouchers,
    },
];

const FINANCIALS_SECTION_PERMISSION = [
    {
        value: PERMISSION.ACCESS_CHARGES,
        label: rolesMessages.accessCharges,
    },
    {
        value: PERMISSION.MANAGE_CHARGES,
        label: rolesMessages.manageCharges,
    },
    {
        value: PERMISSION.ACCESS_PAYMENTS,
        label: rolesMessages.accessPayments,
    },
    {
        value: PERMISSION.MANAGE_PAYMENTS,
        label: rolesMessages.managePayments,
    },
    {
        value: PERMISSION.ACCESS_FINANCIAL_DOCUMENTS,
        label: rolesMessages.accessFinancialDocuments,
    },
    {
        value: PERMISSION.MANAGE_FINANCIAL_DOCUMENTS,
        label: rolesMessages.manageFinancialDocuments,
    },
    {
        value: PERMISSION.ISSUE_FINANCIAL_DOCUMENTS,
        label: rolesMessages.issueFinancialDocuments,
    },
];

const SUBSCRIPTIONS_SECTION_PERMISSION = [
    {
        value: PERMISSION.ACCESS_SUBSCRIPTIONS,
        label: rolesMessages.accessSubscriptions,
    },
    {
        value: PERMISSION.MANAGE_SUBSCRIPTIONS,
        label: rolesMessages.manageSubscriptions,
    },
    {
        value: PERMISSION.ACCESS_TAX_REASONS,
        label: rolesMessages.accessTaxReasons,
    },
    {
        value: PERMISSION.MANAGE_TAX_REASONS,
        label: rolesMessages.manageTaxReasons,
    },
    {
        value: PERMISSION.ACCESS_SERVICE_PLANS,
        label: rolesMessages.accessServicePlans,
    },
    {
        value: PERMISSION.MANAGE_SERVICE_PLANS,
        label: rolesMessages.manageServicePlans,
    },
];

export {
    USERS_SECTIONS_PERMISSION,
    CUSTOMERS_PERMISSION,
    BILLING_SETTINGS_SECTION_PERMISSION,
    DISCOUNTS_SECTION_PERMISSION,
    FINANCIALS_SECTION_PERMISSION,
    SUBSCRIPTIONS_SECTION_PERMISSION,
};
